import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Notify from 'react-notification-system'

import { hideNotification } from './actions'

class Notification extends Component {

  componentWillReceiveProps(nextProps) {
    const { __notification } = nextProps

    if (__notification.get('show')) {
      const notification = __notification.set('onRemove', () => {
        this.props.dispatch(hideNotification())
      })
      this._instance.addNotification(notification.toJS())
    }
  }

  render() {
    return (
      <Notify
        ref={(c) => this._instance = c}
        // eslint-disable-next-line
        style={false}
        noAnimation
      />
    )
  }
}

Notification.propTypes = {
  __notification: PropTypes.object,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __notification: state.notification,
  }
}

export default connect(mapStateToProps)(Notification)



// WEBPACK FOOTER //
// ./src/components/Notification/index.js